import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import SimpleReactLihtBox from "simple-react-lightbox";

ReactDOM.render(
  <SimpleReactLihtBox>
    <App />
  </SimpleReactLihtBox>,
  document.getElementById("root")
);
